<template>
  <div class="mb-2">
    <aha-checkbox
      @change="handleEnableGetPresentation"
      v-model="presentation.enableAudienceRequestPresentation"
      :disabled="isDisableEditPresentation"
    >
      <span>
        {{ $i18nPresenter.t('Approve slide requests') }}
        <AhaSvg
          class="mb-1 ml-1 text-secondary-20"
          name="question"
          v-tooltip="$i18nPresenter.t('Any participant requesting the slides of this presentation will get a sharing link.')"
        />
      </span>
    </aha-checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    from: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    isOwnerOfPresentation() {
      if (this.currentUser.id === this.presentation.userId) {
        return true
      }
      return false
    },
  },
  methods: {
    handleEnableGetPresentation() {
      if (this.from === 'SideCenterShareSlides') {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Share menu > Share slides > Approve slide request',
          !!this.presentation.enableAudienceRequestPresentation,
          null,
          {
            presentationId: this.presentation.id,
            userId: this.currentUser.id,
            isPresentationOwner: this.presentation.userId === this.currentUser.id,
          },
        )
      }
      PresentationApi.updatePresentationRequest(this.presentation.id, {
        enableAudienceRequestPresentation: this.presentation.enableAudienceRequestPresentation,
        presentationId: this.presentation.id,
      })
      if (!this.$store.state.presentation.id) {
        if (this.presentation.enableAudienceRequestPresentation) {
          Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Share > Share a copy > Approve presentation requests checkbox', 'Approve presentation requests: True')
        } else {
          Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Share > Share a Approve > Disable presentation requests checkbox', 'Approve presentation requests: False')
        }
        return
      }
      if (this.presentation.enableAudienceRequestPresentation) {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Enable audience get presentation')
      } else {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Disable audience get presentation')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
